'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './betagroups.routes';
import list from './list';
import edit from './edit';
import add from './add';
import show from './show';
import adduser from './adduser';
import importData from './import';

export default angular.module('updateServerApp.betagroups', [uiRouter, list, edit, add, show, adduser, importData])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/index.js